module.exports = __webpack_public_path__ + "static/indico-logo-final-black-2c90bc18278c7079be836d65a64bb97e.png";